/* eslint-disable */
import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import { useFormik, Form, FormikProvider } from 'formik';
import { Container, Stack, TextField, ButtonGroup, Grid, Typography, Tooltip, IconButton } from '@material-ui/core';
import { LoadingButton } from '@material-ui/lab';
import Divider from '@material-ui/core/Divider';
import Page from '../../../../Page';
import services from '../../Service';
import { ToastContainer, toast } from 'react-toastify';
import MenuItem from '@material-ui/core/MenuItem';
import Card from '@material-ui/core/Card';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import ArrowForwardIosOutlinedIcon from '@material-ui/icons/ArrowForwardIosOutlined';
import ArrowBackIosOutlinedIcon from '@material-ui/icons/ArrowBackIosOutlined';
import Paper from '@material-ui/core/Paper';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import { AlertDialog } from './../../../Common/AlertDialog';
import TokenDecoder from 'src/helpers/TokenDecoder';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

export function CargillsConnect({ handleNext, handleBack, farmerId }) {
    const [message, setMessage] = useState("Delete Confirmation");
    const [EnableConfirmMessage, setEnableConfirmMessage] = useState(false);
    const [farmerCargillsConnectID, setFarmerCargillsConnectID] = useState();
    const [value, setValue] = useState(new Date());
    const [dataGrid, setDataGrid] = useState([]);
    const [nameOfProjectID, setnameOfProjectID] = useState();
    const [projectID, setProjectID] = useState();
    const [factoryType, setFactoryType] = useState(0);
    const [formData, setFormData] = useState({
        introducedID: 0,
        introducedOther: '',
        nameOfIntroducer: '',
        projectsID: 0,
        nameOfProjectID: 0,
        otherProjects: '',
    });
    const [pageProps, setPageProps] = useState({
        editingID: 0,
        Edit: false,
        submitButtonName: "Add",
        pageheadername: "Add Cargills Connect Details "
    });

    const ProjectSaveSchema = Yup.object().shape({
        introducedID: Yup.number().min(1, 'Please Select Introduced to Cargills by').required('Introduced to Cargills by Required'),
        introducedOther: Yup.string()
            .when('introducedID', {
                is: (introducedID) => introducedID == 5,
                then: Yup.string()
                    .required('Other Introduced Is Required'),
                otherwise: Yup.string().nullable(),
            }),
        nameOfIntroducer: Yup.string().matches(/^[aA-zZ\s\.]+$/, "Only alphabets are allowed for this field").nullable(true),
        projectsID: Yup.number().min(1, 'Please Select Involvement in Cargills Projects').required('Involvement in Cargills Projects Required'),
        nameOfProjectID: Yup.number()
            .when('projectsID', {
                is: (projectsID) => projectsID == 1,
                then: Yup.number()
                    .min(1, 'Please Select Name of Project')
                    .required('Name of Project is Required'),
                otherwise: Yup.number().nullable(),
            }),
        otherProjects: Yup.string()
            .when('nameOfProjectID', {
                is: (nameOfProjectID) =>
                    nameOfProjectID == 4,
                then: Yup.string().required('Name of Other Project Required').matches(/[a-zA-Z]/, 'Name should contain at least one letter'),
                otherwise: Yup.string().nullable(),
            }),

    });
    const formik = useFormik({
        initialValues: {
            introducedID: formData.introducedID,
            introducedOther: formData.introducedOther,
            nameOfIntroducer: formData.nameOfIntroducer,
            projectsID: formData.projectsID,
            nameOfProjectID: formData.nameOfProjectID,
            otherProjects: formData.otherProjects,
        },

        validationSchema: ProjectSaveSchema,
        onSubmit: (values) => {
            addCargillsConnect(values)
        },

        enableReinitialize: true

    });

    const { errors, setValues, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;

    useEffect(() => {
        GetCargillsConnectDeatils(farmerId);
    }, []);

    useEffect(() => {
        setnameOfProjectID(formik.values.nameOfProjectID);
    }, [formik.values.nameOfProjectID]);

    useEffect(() => {
        setProjectID(formik.values.projectsID);
    }, [formik.values.projectsID]);


    async function addCargillsConnect(values) {
        if (pageProps.Edit != true) {
            var modelOne = {
                introducedID: parseInt(values.introducedID),
                nameOfIntroducer: values.nameOfIntroducer,
                introducedOther: values.introducedOther,
                projectsID: parseInt(values.projectsID),
                nameOfProjectID: parseInt(values.nameOfProjectID),
                yearOfJoining: value == null ? null : new Date(value).getFullYear() + '-' + '01' + '-' + '01',
                otherProjects: values.otherProjects,
                createdBy: parseInt(TokenDecoder.getUserIDFromToken()),
                farmerID: parseInt(farmerId)
            }

            const res = await services.SaveCargillsConnectDetails(modelOne);
            if (res.statusCode == 'Success') {
                toast.success("Cargills Connect Details Saved Succesfully");
                trackPromise(GetCargillsConnectDeatils(farmerId));
                clearAll();
            } else {
                toast.error(res.message);
            }
        }
        else {
            var modelOne = {
                cargillsConnectID: parseInt(pageProps.editingID),
                introducedID: parseInt(values.introducedID),
                introducedOther: values.introducedOther,
                nameOfIntroducer: values.nameOfIntroducer,
                projectsID: parseInt(values.projectsID),
                nameOfProjectID: parseInt(values.nameOfProjectID),
                OtherProjects: values.otherProjects,
                yearOfJoining: value == null ? null : new Date(value).getFullYear() + '-' + '01' + '-' + '01',
                createdBy: parseInt(TokenDecoder.getUserIDFromToken()),
                farmerID: parseInt(farmerId)
            }

            const res = await services.SaveCargillsConnectDetails(modelOne);
            if (res.statusCode == 'Success') {
                toast.success("Cargills Connect Details Updated Succesfully");
                trackPromise(GetCargillsConnectDeatils(farmerId));
                setPageProps({
                    ...pageProps,
                    editingID: 0,
                    Edit: false,
                    submitButtonName: "Add",
                })
                clearAll();
            } else {
                toast.error(res.message);
            }
        }
    }

    async function GetCargillsConnectDeatils(farmerID) {
        const res = await services.GetCargillsConnectDetails(farmerID);
        setDataGrid(res)
        setFactoryType(parseInt(TokenDecoder.getFactoryTypeFromToken()))
    }

    async function clearAll() {
        formik.resetForm();
    }

    function confirmData(y) {
        if (y) {
            handleDelete(farmerCargillsConnectID);
        }
    }

    function handleConfirm(data) {
        setFarmerCargillsConnectID(data);
        setEnableConfirmMessage(true);
    }

    function handleEdit(rowData, index) {
        var array = [...dataGrid];
        setValues({
            ...values,
            introducedID: rowData.introducedID,
            introducedOther: rowData.introducedOther,
            nameOfIntroducer: rowData.nameOfIntroducer,
            projectsID: rowData.projectsID,
            nameOfProjectID: rowData.nameOfProjectID,
            otherProjects: rowData.otherProjects,
        })
        if (rowData.yearOfJoining == null) {
            setValue(null)
        }
        else {
            setValue(new Date(rowData.yearOfJoining + '-' + '01' + '-' + '01'))
        }
        array.splice(index, 1);

        setPageProps({
            ...pageProps,
            editingID: rowData.cargillsConnectID,
            Edit: true,
            submitButtonName: "Update",
        })
        setDataGrid(array);
    }

    async function handleDelete(data) {
        const res = await services.DeleteCargillsConnectDetails(data);
        if (res.statusCode == 'Success') {
            toast.success(res.message);
            trackPromise(GetCargillsConnectDeatils(farmerId));
        } else {
            toast.error(res.message);
        }
    }

    return (
        <>
            <LoadingComponent />
            <Page title="Cargills Connect  |  FAPS">
                <Container>
                    <FormikProvider value={formik}>
                        <ToastContainer position="bottom-right" pauseOnHover />
                        <Form autoComplete="off"
                            disabled={!(formik.isValid && formik.dirty)}
                            noValidate onSubmit={handleSubmit}
                        >
                            <Card style={{ justifycontent: 'center' }} >
                                <Stack spacing={2} margin={3}>
                                    <Typography variant="h6">
                                        {(factoryType == 1 || factoryType == 3) ? "View Cargills Connect" : "Cargills Connect Details"}
                                        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" >
                                            <ButtonGroup disableElevation variant="outlined" color="primary">
                                                <Tooltip title="Business">
                                                    <IconButton
                                                        variant="outlined"
                                                        color="secondary"
                                                        onClick={handleBack}
                                                    >
                                                        <ArrowBackIosOutlinedIcon />
                                                    </IconButton>
                                                </Tooltip>
                                                <Tooltip title="Certification">
                                                    <IconButton
                                                        variant="outlined"
                                                        color="secondary"
                                                        onClick={handleNext}
                                                    >
                                                        <ArrowForwardIosOutlinedIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            </ButtonGroup>
                                        </Stack>
                                    </Typography>

                                    <Stack direction={{ xs: 'column', sm: 'row' }} style={{ marginTop: '25px' }} spacing={2}>
                                        <TextField select
                                            fullWidth
                                            size="small"
                                            label="Introduced to Cargills by *"
                                            value={formik.values.introducedID}
                                            onChange={(event) => {
                                                formik.handleChange(event)
                                                if (event.target.value === 5) {
                                                    formik.setFieldValue('introducedOther', '');
                                                }
                                            }}
                                            {...getFieldProps('introducedID')}
                                            error={Boolean(touched.introducedID && errors.introducedID)}
                                            helperText={touched.introducedID && errors.introducedID}
                                            disabled={factoryType == 1 || factoryType == 3}
                                        >
                                            <MenuItem key={0} value={0}>Select Introduced to Cargills by </MenuItem>
                                            <MenuItem value={1}>Self Introduced</MenuItem>
                                            <MenuItem value={2}>Cargills Agri Team</MenuItem>
                                            <MenuItem value={3}>Cargills Bank Team</MenuItem>
                                            <MenuItem value={4}>Other Cargills Team</MenuItem>
                                            <MenuItem value={5}>Other</MenuItem>
                                        </TextField>

                                        <TextField
                                            fullWidth
                                            size="small"
                                            label="Other Introduced *"
                                            value={formik.values.introducedOther}
                                            onChange={formik.handleChange}
                                            {...getFieldProps('introducedOther')}
                                            error={Boolean(touched.introducedOther && errors.introducedOther)}
                                            helperText={touched.introducedOther && errors.introducedOther}
                                            disabled={factoryType == 1 || factoryType == 3 || formik.values.introducedID !== 5}
                                        />

                                        <TextField
                                            fullWidth
                                            size="small"
                                            label="Name of Introducer"
                                            value={formik.values.nameOfIntroducer}
                                            onChange={formik.handleChange}
                                            {...getFieldProps('nameOfIntroducer')}
                                            error={Boolean(touched.nameOfIntroducer && errors.nameOfIntroducer)}
                                            helperText={touched.nameOfIntroducer && errors.nameOfIntroducer}
                                            disabled={factoryType == 1 || factoryType == 3}
                                        />

                                        <TextField select
                                            fullWidth
                                            size="small"
                                            label="Involvement in Cargills Projects *"
                                            value={formik.values.projectsID}
                                            onChange={formik.handleChange}
                                            {...getFieldProps('projectsID')}
                                            error={Boolean(touched.projectsID && errors.projectsID)}
                                            helperText={touched.projectsID && errors.projectsID}
                                            disabled={factoryType == 1 || factoryType == 3}
                                        >
                                            <MenuItem key={0} value={0}>Select Involvement in Cargills Projects </MenuItem>
                                            <MenuItem value={1}>Yes</MenuItem>
                                            <MenuItem value={2}>No</MenuItem>

                                        </TextField>
                                    </Stack>

                                    <Divider variant="middle" />
                                    {formik.values.projectsID == 1 ?
                                        <Typography variant="h8">
                                            <b>{"Project Details"}</b>
                                        </Typography> : null}

                                    <Stack direction={{ xs: 'column', sm: 'row' }} style={{ marginTop: '25px' }} spacing={2}>

                                        {formik.values.projectsID == 1 ?

                                            <TextField select
                                                fullWidth
                                                size="small"
                                                label="Name of Project *"
                                                value={formik.values.nameOfProjectID}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('nameOfProjectID')}
                                                error={Boolean(touched.nameOfProjectID && errors.nameOfProjectID)}
                                                helperText={touched.nameOfProjectID && errors.nameOfProjectID}
                                                disabled={factoryType == 1 || factoryType == 3}
                                            >
                                                <MenuItem key={0} value={0}> Select Name of Project</MenuItem>
                                                <MenuItem value={1}>Cargills AMP</MenuItem>
                                                <MenuItem value={2}>FAO</MenuItem>
                                                <MenuItem value={3}>IUCN</MenuItem>
                                                <MenuItem value={4}>Other</MenuItem>
                                            </TextField> : null}
                                        {formik.values.nameOfProjectID == 4 && formik.values.projectsID == 1 ?

                                            <TextField
                                                fullWidth
                                                size="small"
                                                label="Other Projects *"
                                                value={formik.values.otherProjects}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('otherProjects')}
                                                error={Boolean(touched.otherProjects && errors.otherProjects)}
                                                helperText={touched.otherProjects && errors.otherProjects}
                                                disabled={factoryType == 1 || factoryType == 3}
                                            />

                                            : null}

                                        {formik.values.projectsID == 1 ?
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    fullWidth
                                                    size="small"
                                                    label="Year of Joined *"
                                                    openTo="year"
                                                    views={['year']}
                                                    value={value}
                                                    onChange={(newValue) => {
                                                        setValue(newValue);
                                                    }}
                                                    maxDate={new Date()}
                                                    disabled={factoryType == 1 || factoryType == 3}
                                                    renderInput={(params) =>
                                                        <TextField
                                                            fullWidth
                                                            size="small"
                                                            {...params}
                                                        />}
                                                />
                                            </LocalizationProvider>
                                            : null}
                                    </Stack>
                                    <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                        <LoadingButton
                                            size="medium"
                                            type="button"
                                            variant="outlined"
                                            color='error'
                                            onClick={() => clearAll()}
                                            disabled={pageProps.Edit || factoryType == 1 || factoryType == 3}
                                        >
                                            Clear
                                        </LoadingButton>
                                        <LoadingButton
                                            size="medium"
                                            type="submit"
                                            variant="outlined"
                                            color='secondary'
                                            disabled={factoryType == 1 || factoryType == 3}
                                        >
                                            {pageProps.submitButtonName}
                                        </LoadingButton>
                                    </Stack>
                                    <Divider variant="middle" />
                                    {dataGrid.length > 0 ?
                                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                            <Card style={{ justifycontent: 'center', width: '65rem' }} >
                                                <TableContainer component={Paper} >
                                                    <Table aria-label="caption table">
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell align="center">Name Of Project</TableCell>
                                                                <TableCell align="center">Other</TableCell>
                                                                <TableCell align="center">Year of Joining</TableCell>
                                                                {(factoryType == 1 || factoryType == 3) ? null :
                                                                    <TableCell align="center">Action</TableCell>}
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {dataGrid.map((rowData, index) => (
                                                                <TableRow key={index}>
                                                                    <TableCell align="center" component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                        {rowData.projectsID == 2 ? '-' : rowData.nameOfProjectID == 1 ? 'Cargills AMP' :
                                                                            rowData.nameOfProjectID == 2 ? 'FAO' : rowData.nameOfProjectID == 3 ? 'IUCN' : 'Other'}
                                                                    </TableCell>
                                                                    <TableCell align="center" component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                        {rowData.projectsID == 2 ? '-' : rowData.nameOfProjectID == 1 ? '-' :
                                                                            rowData.otherProjects}
                                                                    </TableCell>

                                                                    <TableCell align="center" component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                        {rowData.projectsID == 2 ? '-' : rowData.yearOfJoining == null ? '-' : rowData.yearOfJoining}
                                                                    </TableCell>
                                                                    {(factoryType == 1 || factoryType == 3) ? null :
                                                                        <TableCell align="center" component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                            {pageProps.Edit != true ?
                                                                                <Tooltip title="Edit">
                                                                                    <IconButton
                                                                                        variant="outlined"
                                                                                        onClick={() => handleEdit(rowData, index)}>
                                                                                        <EditIcon />
                                                                                    </IconButton>
                                                                                </Tooltip> : null}
                                                                            <Tooltip title="Delete">
                                                                                <IconButton
                                                                                    variant="outlined"
                                                                                    color="error"
                                                                                    onClick={(e) => handleConfirm(rowData.cargillsConnectID)}
                                                                                >
                                                                                    <DeleteIcon />
                                                                                </IconButton>
                                                                            </Tooltip>
                                                                        </TableCell>}
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </Card>
                                        </Stack>
                                        : null}
                                </Stack>
                            </Card>
                        </Form>
                    </FormikProvider>
                </Container>
                <div hidden={true}>
                    <Grid item>
                        <AlertDialog confirmData={confirmData} headerMessage={message} viewPopup={EnableConfirmMessage}
                            discription={"Are you sure want to delete Cargills Connect details ?"} setViewPopup={setEnableConfirmMessage} />
                    </Grid>
                </div>
            </Page>
        </>
    );
}